import axios from 'axios';

const API_BASE_URL = 'https://api.novadent.site';

// Create axios instance with default config
const apiClient = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor
apiClient.interceptors.request.use(
  (config) => {
    console.log('Making API request:', config.method?.toUpperCase(), config.url);
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor
apiClient.interceptors.response.use(
  (response) => {
    console.log('API Response:', response.data);
    
    // Your backend returns: { success: true/false, data: {...}, message: "..." }
    if (response.data && response.data.success === true) {
      // Return the data part for successful responses
      return response.data.data;
    } else if (response.data && response.data.success === false) {
      // Handle backend errors
      const errorMessage = response.data.message || 'An error occurred';
      const errorDetails = response.data.errors || null;
      
      const customError = new Error(errorMessage);
      customError.validationErrors = errorDetails;
      throw customError;
    }
    
    // Fallback - return the whole response data
    return response.data;
  },
  (error) => {
    console.error('API Request Failed:', error);
    
    // Handle HTTP errors (4xx, 5xx)
    if (error.response && error.response.data) {
      const errorMessage = error.response.data.message || error.message || 'An error occurred';
      const errorDetails = error.response.data.errors || null;
      
      const customError = new Error(errorMessage);
      customError.validationErrors = errorDetails;
      return Promise.reject(customError);
    }
    
    return Promise.reject(error);
  }
);

class ApiService {
  // Dashboard
  async getDashboardStats() {
    return apiClient.get('/api/dashboard/stats');
  }

  async getRecentPatients() {
    return apiClient.get('/api/patients/recent');
  }

  // Patient Management
  async createPatient(patientData) {
    console.log('Creating patient with data:', patientData);
    
    const jsonData = {
      fullName: patientData.fullName || '',
      phone: patientData.phone || '',
      age: parseInt(patientData.age) || 0,
      gender: patientData.gender || '',
      address: patientData.address || '',
      allergies: patientData.allergies || '',
      chronicConditions: patientData.chronicConditions || '',
      pastSurgeries: patientData.pastSurgeries || ''
    };

    console.log('Sending JSON data:', jsonData);
    return apiClient.post('/api/patients', jsonData);
  }

  async searchPatients(query) {
    return apiClient.get(`/api/patients/search?q=${encodeURIComponent(query)}`);
  }

  async getPatient(id) {
    return apiClient.get(`/api/patients/${id}`);
  }

  async updatePatient(id, patientData) {
    return apiClient.put(`/api/patients/${id}`, patientData);
  }

  // Visit Management
  async createVisit(patientId, visitData) {
    return apiClient.post(`/api/patients/${patientId}/visits`, visitData);
  }

  async getPatientVisits(patientId) {
    return apiClient.get(`/api/patients/${patientId}/visits`);
  }

  async getVisit(id) {
    return apiClient.get(`/api/visits/${id}`);
  }

  async updateVisit(id, visitData) {
    return apiClient.put(`/api/visits/${id}`, visitData);
  }

  // --- NEW: Delete Visit Function ---
  async deleteVisit(id) {
    return apiClient.delete(`/api/visits/${id}`);
  }

  // File Management
  async uploadPatientPhoto(patientId, photoFile) {
    const formData = new FormData();
    formData.append('photo', photoFile);
    
    return apiClient.post(`/api/patients/${patientId}/photo`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  }
}

export default new ApiService();